module.exports = __webpack_public_path__ + "static/media/features-invoices.d38b6ffe.png";